import { useRef } from "react";

import { EmailContentFlow, EmailEntryPoint } from "@simplyk/common";

import { useTranslate } from "@/common/hooks/useTranslate";
import { useOpenEmailEditor } from "@/components/EmailEditor/useOpenEmailEditor";
import { CellProps } from "@/dashboard-design-system/DashboardTableCell";

export const useEmailCellAction = (entryPoint: EmailEntryPoint): NonNullable<CellProps["emailAction"]> => {
  const { t } = useTranslate();
  const { openEmailEditor } = useOpenEmailEditor();
  const isOpeningRef = useRef(false);

  return {
    label: t("dashboard", "paymentsPage.table.cell.sendEmail"),
    onSendEmail: (email) => {
      if (isOpeningRef.current) {
        return;
      }
      isOpeningRef.current = true;
      void openEmailEditor({
        recipientEmails: [email],
        entryPoint,
        flow: EmailContentFlow.Quick,
        emailType: null,
      }).finally(() => {
        isOpeningRef.current = false;
      });
    },
  };
};
